import { Component, Prop, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import InputTextAreaComponent from "../input-textarea/input-textarea.component.vue";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { STATUS } from "@/models/common-interface/common.interface";
import { utils } from "@/utils/utils";
import {
  FormFieldContents,
  LetterOfReference,
} from "@/models/letter-of-reference-form/letter-of-reference-from.interface";
import { LETTER_OF_REFERENCE_QUERY } from "@/graphql/letter-of-reference-form-query";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import { certificationFormApi } from "@/providers/apis/certification-form";

@Component({
  name: "letter-of-reference-preview",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-form-textarea": InputTextAreaComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
  },
})
export default class LetterOfReferencePreviewComponent extends Vue {
  @Prop()
  public previewData!: any[];
  @Prop()
  public isReviewerPreviewForm: any;
  @Prop()
  public referenceSelectedIdx: any;
  @Prop()
  public applicationId!: string;
  @Prop()
  public activeRefrealEmail!: string;
  @Prop()
  public progressStatus!: string;

  public applicationData: Array<LetterOfReference> = [];
  public formData: FormFieldContents[] = [];
  public formTitle = {
    referenceTitle: "",
    referenceSubTitle: "",
  };
  public isLoading = false;
  public toogleStatus = false;
  public referenceStatus = "";
  public storeReferenceStatus: any[] = [];
  public activeRefreal: any;
  public isLargeLoading = false;
  public status: string[] = [STATUS.accepted, STATUS.notAccepted];
  public errorMessage = "";

  public created() {
    this.isLoading = true;
    this.$apollo
      .query({
        query: gql`query ${LETTER_OF_REFERENCE_QUERY}`,
      })
      .then((result) => {
        this.applicationData = result.data.letterOfReferences.data;
        this.formData = this.applicationData[0].attributes.form_fields;
        this.isLoading = false;
      });

    for (let index = 0; index < this.previewData.length; index++) {
      if (this.storeReferenceStatus.length) {
        this.storeReferenceStatus.push({
          index: index,
          email: this.previewData[index].email,
          status: this.previewData[index].status,
        });
      } else {
        this.storeReferenceStatus = [
          {
            index: index,
            email: this.previewData[index].email,
            status: this.previewData[index].status,
          },
        ];
      }
    }
    this.activeRefreal = this.previewData.find((data: any) => {
      return data.email === this.activeRefrealEmail;
    });

    this.referenceNameAndAddressBuild();
  }

  public referenceNameAndAddressBuild() {
    //for Reference Details
    this.activeRefreal.data.letterOfReferenceReferenceDetails.referenceFullName = `${this.activeRefreal.data.letterOfReferenceReferenceDetails.referenceFirstName} ${this.activeRefreal.data.letterOfReferenceReferenceDetails.referenceLastName}`;
    this.activeRefreal.data.letterOfReferenceReferenceDetails.fullAddress = `${this.activeRefreal.data.letterOfReferenceReferenceDetails.addressLine1}\n\n${this.activeRefreal.data.letterOfReferenceReferenceDetails.addressLine2}\n\n${this.activeRefreal.data.letterOfReferenceReferenceDetails.city}  |  ${this.activeRefreal.data.letterOfReferenceReferenceDetails.state}  |  ${this.activeRefreal.data.letterOfReferenceReferenceDetails.zip}`;

    //Applicant Details
    this.activeRefreal.data.letterOfReferenceApplicantInformation.applicantFullName = `${this.activeRefreal.data.letterOfReferenceApplicantInformation.applicantFirstName} ${this.activeRefreal.data.letterOfReferenceApplicantInformation.applicantLastName}`;
  }
  fieldUpdate(inputName: string) {
    if (!this.isReviewerPreviewForm && inputName === "referenceFullName") {
      return true;
    } else if (
      this.isReviewerPreviewForm &&
      (inputName === "referenceFirstName" ||
        inputName === "referenceLastName" ||
        inputName === "addressLine1" ||
        inputName === "addressLine2" ||
        inputName === "state" ||
        inputName === "city" ||
        inputName === "zip" ||
        inputName === "applicantFirstName" ||
        inputName === "applicantLastName")
    ) {
      return true;
    } else {
      return false;
    }
  }

  public async selectStatus(status: string, referenceEmail: string) {
    this.referenceStatus = status;
    this.isLargeLoading = true;
    const referencePayload = {
      id: this.applicationId,
      email: referenceEmail,
      status: status,
    };

    this.toogleStatus = !this.toogleStatus;
    await certificationFormApi
      .updateReferenceStatus(referencePayload)
      .then((data) => {
        this.$emit("referenceUpdated", {
          email: referenceEmail,
          idx: this.referenceSelectedIdx,
        });
        this.isLargeLoading = false;
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLargeLoading = false;
      });
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  // This method for change status word for class

  public statusWordChange(status: string) {
    return utils.statusCaseChange(status);
  }

  public validationDisable(groupName = "") {
    const tempPickList = JSON.parse(JSON.stringify(this.formData)); // It uses of fix the "Cannot assign to read only property 'attributes' of object";
    switch (groupName) {
      case "applicantType":
        if (
          this.activeRefreal.data.letterOfReferenceApplicantInformation
            .applicantType === "Professional"
        ) {
          tempPickList.map((data: any) => {
            if (data !== null && data) {
              if (data.parent_slug === "letterOfReferenceReferenceDetails") {
                delete data.fields.formInputs[2][1].validate;
                return tempPickList;
              }
            }
          });
          this.formData = tempPickList;
        } else if (
          this.activeRefreal.data.letterOfReferenceApplicantInformation
            .applicantType === "Personal"
        ) {
          tempPickList.map((data: any) => {
            if (data !== null && data) {
              if (data.parent_slug === "letterOfReferenceReferenceDetails") {
                delete data.fields.formInputs[1][0].validate;
                delete data.fields.formInputs[2][0].validate;
                delete data.fields.formInputs[2][1].validate;
                return tempPickList;
              }
            }
          });
          this.formData = tempPickList;
        }
        break;
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
}
